const TYPE_MOVEMENT = {
  INVERSION: 'Inversion',
  REINVERSION: 'Reinversion',
  RESERVA: 'Reserva',
  GASTO: 'Gasto',
  VENTA: 'Venta',
  DINERO_DISPONIBLE: 'Dinero Disponible',
  DINERO_DISPONIBLE_PARA_REINVERSION: 'Dinero Reinversion',
  GANANCIAS: 'Ganancias',
  DEVOLUCION: 'Devolucion'
}

const OPERATION = {
  VENDER: 'Vender',
  PEDIR: 'Pedir'
}

const STATUS_ORDER = {
  OPENED: 'Abierto',
  CANCELED: 'Cancelado',
  CLOSED: 'Cerrado'
}

const STATUS_SALE = {
  RESERVED: 'Reservada',
  CANCELED: 'Cancelado',
  FINISHED: 'Finalizada',
  RETURNED: 'Devuelto'
}

const TYPE_SALE = {
  MAYOR: 'Mayor',
  MENOR: 'Menor',
  COSTO: 'Costo',
  OTRO: 'Otro'
}

const CHANGE = {
  QUANTITY: 'quantity',
  PRICE: 'price',
  VARIANT_COLOR: 'variant_color',
  VARIANT_SIZE: 'variant_size'
}

const STATUS_STORE_CREDIT = {
  PENDING: 'pendiente',
  USED: 'usado',
  EXPIRED: 'vencido',
  CANCELED: 'cancelado'
}

export {
  TYPE_MOVEMENT,
  OPERATION,
  STATUS_ORDER,
  STATUS_SALE,
  TYPE_SALE,
  CHANGE,
  STATUS_STORE_CREDIT
}